import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NguiInviewModule, NguiListModule, NguiUtilsModule } from '@ngui/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { EmailEditorModule } from 'angular-email-editor';
import { GaugeChartModule } from 'angular-gauge-chart';
import { LaddaModule } from 'angular2-ladda';
import { TextMaskModule } from 'angular2-text-mask';
import { QRCodeModule } from 'angularx-qrcode';
import { NgChartsModule } from 'ng2-charts';
import { EllipsisModule } from 'ngx-ellipsis';
import { FileSaverModule } from 'ngx-filesaver';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxLoadingModule } from 'ngx-loading';
import { MomentModule } from 'ngx-moment';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
// import { FullCalendarModule } from "primeng/fullcalendar";
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SpeedDialModule } from 'primeng/speeddial';
import { SpinnerModule } from 'primeng/spinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { AppCodeModule } from 'src/app/app.code.component';
import { AddressSelectionInputComponent } from '../components/address-selection-input/address-selection-input.component';
import { OrderTypeComparisonChartComponent } from '../components/charts/order-type-comparison-chart/order-type-comparison-chart.component';
import { SalesSummaryLineChartComponent } from '../components/charts/sales-summary-line-chart/sales-summary-line-chart.component';
import { CheckSearchComponent } from '../components/check-search/check-search.component';
import { CheckHeaderComponent } from '../components/check/check-header/check-header.component';
import { CheckItemsComponent } from '../components/check/check-items/check-items.component';
import { CheckPaymentComponent } from '../components/check/check-payment/check-payment.component';
import { CommandCenterHeaderComponent } from '../components/command-center-header/command-center-header.component';
import { ContactInfoFormComponent } from '../components/contact-info-form/contact-info-form.component';
import { FocusSidebarComponent } from '../components/focus-sidebar/focus-sidebar.component';
import { GiftCardPaymentComponent } from '../components/gift-card-payment/gift-card-payment.component';
import { ImageCropperComponent } from '../components/image-cropper/image-cropper.component';
import { LoyaltyAccountLookupPostComponent } from '../components/loyalty-account-lookup-post/loyalty-account-lookup-post.component';
import { OrderPromoCodeComponent } from '../components/order-promo-code/order-promo-code.component';
import { PaymentProfileSetupComponent } from '../components/payment-profile-setup/payment-profile-setup.component';
import { PosPrintPrinterSelectComponent } from '../components/pos-print-printer-select/pos-print-printer-select.component';
import { QuickbooksOauthConnectComponent } from '../components/quickbooks-oauth-connect/quickbooks-oauth-connect.component';
import { RecordControlFooterComponent } from '../components/record-control-footer/record-control-footer.component';
import { ReleaseNotesComponent } from '../components/release-notes/release-notes.component';
import { TableColumnPickerComponent } from '../components/table-column-picker/table-column-picker.component';
import { TermsAndConditionsComponent } from '../components/terms-and-conditions/terms-and-conditions.component';
import { TermsOfServiceFooterComponent } from '../components/terms-of-service-footer/terms-of-service-footer.component';
import { VenueHeaderComponent } from '../components/venue-header/venue-header.component';
import { VenueInfoFooterComponent } from '../components/venue-info-footer/venue-info-footer.component';
import { NoWhitespaceValidatorDirective } from '../directives/no-whitespace-validator.directive';
import { ArrayFilterPipe } from '../pipes/array-filter.pipe';
import { ArrayFindPipe } from '../pipes/array-find.pipe';
import { ArrayObjectPipe } from '../pipes/array-object.pipe';
import { CanvasUnavailablePipe } from '../pipes/canvasUnavailable.pipe';
import { FilterPipe } from '../pipes/filter.pipe';
import { ItemOutOfStockPipe } from '../pipes/itemOutOfStockPipe';
import { ItemUnavailablePipe } from '../pipes/ItemUnavailable.pipe';
import { PhoneFormatPipe } from '../pipes/phone-format.pipe';
import { SafeUrlPipe } from '../pipes/safe-url.pipe';
import { TagFilterPipe } from '../pipes/tagFilter.pipe';

// import { CreditCardDirectivesModule } from 'angular-cc-library';

@NgModule({
	declarations: [
		AddressSelectionInputComponent,
		ArrayFilterPipe,
		ArrayFindPipe,
		ArrayObjectPipe,
		CanvasUnavailablePipe,
		PhoneFormatPipe,
		CheckHeaderComponent,
		CheckItemsComponent,
		CheckPaymentComponent,
		CheckSearchComponent,
		CommandCenterHeaderComponent,
		ContactInfoFormComponent,
		FilterPipe,
		FocusSidebarComponent,
		GiftCardPaymentComponent,
		ImageCropperComponent,
		ItemOutOfStockPipe,
		ItemUnavailablePipe,
		LoyaltyAccountLookupPostComponent,
		NoWhitespaceValidatorDirective,
		OrderPromoCodeComponent,
		OrderTypeComparisonChartComponent,
		PaymentProfileSetupComponent,
		PosPrintPrinterSelectComponent,
		QuickbooksOauthConnectComponent,
		RecordControlFooterComponent,
		ReleaseNotesComponent,
		SafeUrlPipe,
		SalesSummaryLineChartComponent,
		TableColumnPickerComponent,
		TagFilterPipe,
		TermsAndConditionsComponent,
		TermsOfServiceFooterComponent,
		VenueInfoFooterComponent,
		VenueHeaderComponent,
	],
	imports: [
		AccordionModule,
		AppCodeModule,
		AutoCompleteModule,
		BreadcrumbModule,
		ButtonModule,
		CalendarModule,
		CardModule,
		CarouselModule,
		ChartModule,
		CheckboxModule,
		ChipModule,
		ChipsModule,
		CodeHighlighterModule,
		ColorPickerModule,
		CommonModule,
		ConfirmDialogModule,
		ContextMenuModule,
		CreditCardDirectivesModule,
		DataViewModule,
		DialogModule,
		DividerModule,
		DragDropModule,
		DropdownModule,
		DynamicDialogModule,
		EditorModule,
		EmailEditorModule,
		EllipsisModule,
		FieldsetModule,
		FileSaverModule,
		FileUploadModule,
		FormsModule,
		FontAwesomeModule,
		FormsModule,
		// FullCalendarModule,
		GalleriaModule,
		GoogleMapsModule,
		GaugeChartModule,
		GooglePlaceModule,
		ImageCropperModule,
		InplaceModule,
		InputMaskModule,
		InputNumberModule,
		InputSwitchModule,
		InputTextareaModule,
		InputTextModule,
		LaddaModule,
		LightboxModule,
		ListboxModule,
		MatStepperModule,
		MatCheckboxModule,
		MatButtonModule,
		MatInputModule,
		MatAutocompleteModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatRadioModule,
		MatSelectModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatMenuModule,
		MatSidenavModule,
		MatToolbarModule,
		MatListModule,
		MatGridListModule,
		MatCardModule,
		MatTabsModule,
		MatExpansionModule,
		MatButtonToggleModule,
		NgChartsModule,
		MatChipsModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatDialogModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		MatMomentDateModule,
		MegaMenuModule,
		MenubarModule,
		MenuModule,
		MessageModule,
		MessagesModule,
		MomentModule,
		MultiSelectModule,
		// NgbModule,
		NgScrollbarModule,
		NgxChartsModule,
		NgxLoadingModule,
		NguiListModule,
		NguiInviewModule,
		NguiUtilsModule,
		OrderListModule,
		OrganizationChartModule,
		OverlayPanelModule,
		PaginatorModule,
		PanelMenuModule,
		PanelModule,
		PasswordModule,
		PickListModule,
		ProgressBarModule,
		ProgressSpinnerModule,
		QRCodeModule,
		RadioButtonModule,
		RatingModule,
		ReactiveFormsModule,
		RippleModule,
		RouterModule,
		ScrollPanelModule,
		ScrollTopModule,
		SelectButtonModule,
		SidebarModule,
		SkeletonModule,
		SlideMenuModule,
		SliderModule,
		SpeedDialModule,
		SpinnerModule,
		SplitButtonModule,
		StepsModule,
		TableModule,
		TabMenuModule,
		TabViewModule,
		TagModule,
		TerminalModule,
		TextMaskModule,
		TieredMenuModule,
		TimelineModule,
		ToggleButtonModule,
		ToolbarModule,
		TooltipModule,
		TreeModule,
		TreeTableModule,
		VirtualScrollerModule,
	],
	exports: [
		// FullCalendarModule,
		AccordionModule,
		AddressSelectionInputComponent,
		AppCodeModule,
		ArrayFilterPipe,
		ArrayFindPipe,
		AutoCompleteModule,
		BreadcrumbModule,
		ButtonModule,
		CalendarModule,
		CanvasUnavailablePipe,
		PhoneFormatPipe,
		ArrayObjectPipe,
		CardModule,
		CarouselModule,
		ChartModule,
		CheckboxModule,
		CheckHeaderComponent,
		CheckItemsComponent,
		CheckPaymentComponent,
		CheckSearchComponent,
		ChipModule,
		ChipsModule,
		CodeHighlighterModule,
		ColorPickerModule,
		CommonModule,
		ContactInfoFormComponent,
		ConfirmDialogModule,
		ContextMenuModule,
		CreditCardDirectivesModule,
		DataViewModule,
		DialogModule,
		DividerModule,
		DragDropModule,
		DropdownModule,
		DynamicDialogModule,
		EditorModule,
		EllipsisModule,
		EmailEditorModule,
		FieldsetModule,
		FileSaverModule,
		FileUploadModule,
		FilterPipe,
		FocusSidebarComponent,
		FontAwesomeModule,
		FormsModule,
		GalleriaModule,
		GaugeChartModule,
		GiftCardPaymentComponent,
		GoogleMapsModule,
		GooglePlaceModule,
		ImageCropperComponent,
		ImageCropperModule,
		InplaceModule,
		InputMaskModule,
		InputNumberModule,
		InputSwitchModule,
		InputTextareaModule,
		InputTextModule,
		ItemOutOfStockPipe,
		ItemUnavailablePipe,
		LaddaModule,
		LightboxModule,
		ListboxModule,
		LoyaltyAccountLookupPostComponent,
		MatAutocompleteModule,
		MatButtonModule,
		MatButtonToggleModule,
		MatCardModule,
		MatCheckboxModule,
		MatChipsModule,
		MatDatepickerModule,
		MatDialogModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatGridListModule,
		MatIconModule,
		MatInputModule,
		MatListModule,
		MatMenuModule,
		MatMomentDateModule,
		MatPaginatorModule,
		MatProgressBarModule,
		MatProgressSpinnerModule,
		MatRadioModule,
		MatSelectModule,
		MatSidenavModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatSnackBarModule,
		MatSortModule,
		MatStepperModule,
		MatTableModule,
		MatTabsModule,
		MatToolbarModule,
		MatTooltipModule,
		MegaMenuModule,
		MenubarModule,
		MenuModule,
		MessageModule,
		MessagesModule,
		MomentModule,
		MultiSelectModule,
		NgbModule,
		NgChartsModule,
		NgScrollbarModule,
		NguiInviewModule,
		NguiListModule,
		NguiUtilsModule,
		NgxChartsModule,
		NgxLoadingModule,
		NoWhitespaceValidatorDirective,
		OrderListModule,
		OrderPromoCodeComponent,
		OrderTypeComparisonChartComponent,
		OrganizationChartModule,
		OverlayPanelModule,
		PaginatorModule,
		PanelMenuModule,
		PanelModule,
		PasswordModule,
		PaymentProfileSetupComponent,
		PickListModule,
		PosPrintPrinterSelectComponent,
		ProgressBarModule,
		ProgressSpinnerModule,
		QRCodeModule,
		QuickbooksOauthConnectComponent,
		RadioButtonModule,
		RatingModule,
		ReactiveFormsModule,
		RecordControlFooterComponent,
		ReleaseNotesComponent,
		RouterModule,
		SafeUrlPipe,
		SalesSummaryLineChartComponent,
		ScrollPanelModule,
		ScrollTopModule,
		SelectButtonModule,
		SidebarModule,
		SkeletonModule,
		SlideMenuModule,
		SliderModule,
		SpeedDialModule,
		SpinnerModule,
		SplitButtonModule,
		StepsModule,
		TableColumnPickerComponent,
		TableModule,
		TabMenuModule,
		TabViewModule,
		TagFilterPipe,
		TagModule,
		TerminalModule,
		TermsAndConditionsComponent,
		TermsOfServiceFooterComponent,
		TextMaskModule,
		TieredMenuModule,
		TimelineModule,
		ToggleButtonModule,
		ToolbarModule,
		TooltipModule,
		TreeModule,
		TreeTableModule,
		VenueInfoFooterComponent,
		VirtualScrollerModule,
		VenueHeaderComponent,
	],
	providers: [ConfirmationService, MessageService],
})
export class SharedModule {
	constructor(library: FaIconLibrary) {
		library.addIconPacks(fas, far, fal, fab, fad);
	}
}
